<app-collapsible-container
    [id]="'imports'"
    [title]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.IMPORT'"
    [icon]="'i-upload'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <app-import-contacts (elementSizeModification)="elementSizeModification.emit()"></app-import-contacts>
</app-collapsible-container>
